<template>
  <div class="bg-fa" id="loading-container">
    <div class="dyh-line-group" style="  justify-content: space-between;">
      <b class="dyh-line-group-label">待审核商品信息</b>
      <el-input size="mini" placeholder="模糊查询,空则显示全部" v-model="search_value" @click="searchGoods()"
        class="input-with-select">
      </el-input>

      <!-- <el-button size="mini" @click="checkModify('DialogVisible')" type="primary" style="margin-left: 10px">
        批 量 修 改
      </el-button> -->

      <div>
        <el-button size="mini" style="margin-left: 10px" type="primary" @click="audit">
          审 核
        </el-button>
      </div>
    </div>
    <div class="dyh-body-group">
      <ve-table border-x border-y ref="goodstableRef" :columns="columns" :fixed-header="true" v-if="goodsDataShow"
        :scroll-width="1800" :virtual-scroll-option="virtualScrollOption" :table-data="goods_list"
        :style="`min-height:360px`" style="width: 100%; overflow: auto" :event-custom-option="eventCustomOption"
        :maxHeight="505" :checkbox-option="checkboxOption" rowKeyFieldName="rowKey" :cell-style-option="cellStyleOption"
        enable="true" />
      <div class="in-line un-selected">
        调整每页显示条数
        <el-select class="un-selected" v-model="pagination.pageSize" :disabled="pagination.disabled"
          @change="getAuditList" style="margin: 0 20px; width: 100px !important" placeholder="请选择" size="mini">
          <el-option v-for="item in pagination.pageSizes" :key="item" :label="item + '条 / 页'" :value="item">
          </el-option>
        </el-select>

        <el-button type="primary" :disabled="pagination.disabled" @click="pageChange('-')" plain
          size="mini">上一页</el-button>
        <div style="margin: 0 20px; display: flex; align-items: center">
          第<el-input :min="1" type="number" @change="getAuditList" :disabled="pagination.disabled" :max="100"
            style="margin: 0 20px; width: 100px !important" id="page-input" size="mini"
            v-model="pagination.currentPage"></el-input>
          页
        </div>
        <el-button type="primary" :disabled="pagination.disabled" @click="pageChange('+')" plain
          size="mini">下一页</el-button>
      </div>
    </div>

    <el-dialog title="商品详情" :visible.sync="formDialog" top="10vh" width="940px" :lock-scroll="true"
      :close-on-click-modal="false" @close="closeDialog('close')" center>
      <div class="dialog-fa">
        <div style="width: 1050px">
          <el-form :rules="rules" ref="ruleForm" :model="goodsData" :inline="true" size="mini" label-width="100px">
            <el-form-item label="商品条码：" prop="barcode">
              <el-input v-model="goodsData.barcode" placeholder="请输入商品条码"></el-input>
            </el-form-item>
            <el-form-item label="商品名称：" prop="item_name">
              <el-input v-model="goodsData.item_name" placeholder="请输入商品名称"></el-input>
            </el-form-item>

            <el-form-item label="商品简称：" prop="item_subname">
              <el-input v-model="goodsData.item_subname" placeholder="请输入商品简称"></el-input>
            </el-form-item>
            <el-form-item label="拼音码：" prop="pym">
              <el-input v-model="goodsData.pym" placeholder="请输入拼音码"></el-input>
            </el-form-item>
            <el-form-item label="类别：" prop="class_no">
              <el-cascader placeholder="试试搜索：酒水" :props="cascaderProps" :show-all-levels="false" :options="classList.t2"
                v-model="goodsData.class_no" filterable></el-cascader>
            </el-form-item>
            <el-form-item label="建议售价：" prop="advise_price">
              <el-input v-model="goodsData.advise_price" placeholder="请输入建议售价"></el-input>
            </el-form-item>
            <el-form-item label="单位：" prop="unit_name">
              <el-input v-model="goodsData.unit_name" placeholder="请输入单位"></el-input>
            </el-form-item>
            <el-form-item label="等级：" prop="grade">
              <el-input v-model="goodsData.grade" placeholder="请输入商品等级"></el-input>
            </el-form-item>
            <el-form-item label="产地：" prop="product_area">
              <el-input v-model="goodsData.product_area" placeholder="请输入商品产地"></el-input>
            </el-form-item>
            <el-form-item label="规格：" prop="item_size">
              <el-input v-model="goodsData.item_size" placeholder="请输入商品规格"></el-input>
            </el-form-item>
            <el-form-item label="保质期：" prop="shelf_life">
              <el-input v-model="goodsData.shelf_life" placeholder="请输入商品保质期"></el-input>
            </el-form-item>
            <el-form-item label="品牌：" prop="brand_name">
              <el-input v-model="goodsData.brand_name" placeholder="请输入品牌"></el-input>
            </el-form-item>
            <el-form-item label="称重标识：" prop="weight_flag">
              <el-radio-group v-model="goodsData.weight_flag" size="mini">
                <el-radio-button label="0">普通</el-radio-button>
                <el-radio-button label="1">称重</el-radio-button>
                <el-radio-button label="2">计数</el-radio-button>
              </el-radio-group>
            </el-form-item>

          </el-form>
          <el-form :rules="rules" :model="goodsData" :inline="true" size="mini" label-width="100px">
            <el-form-item label="商品正面：">
              <div class="form-image-info" @click="chooseImage('image_front')">
                <el-image class="form-image-info" @click="chooseImage('image_front')" error="onErrorImg(item,index)"
                  :src="goodsData.image_front.url">
                  点击选择
                </el-image>
              </div>
              <div v-if="goodsData.image_front.url" @click="deleteImage('image_front')" class="close" style="">╳</div>
            </el-form-item>

            <el-form-item label="商品条码图：">
              <div class="form-image-info" @click="chooseImage('image_barcode')"><el-image class="form-image-info"
                  error="onErrorImg(item,index)" :src="goodsData.image_barcode.url">
                  点击选择
                </el-image></div>

              <div v-if="goodsData.image_barcode.url" @click="deleteImage('image_barcode')" class="close" style="">╳
              </div>
            </el-form-item>
            <el-form-item label="商品全貌：">
              <div class="form-image-info" @click="chooseImage('image_desc')">
                <el-image class="form-image-info" @click="chooseImage('image_desc')" error="onErrorImg(item,index)"
                  :src="goodsData.image_desc.url">
                  点击选择
                </el-image>
              </div>
              <div v-if="goodsData.image_desc.url" @click="deleteImage('image_desc')" class="close" style="">╳</div>
            </el-form-item>
            <el-form-item style="width: 92%; text-align: right">
              <el-button size="lg" type="primary" @click="closeDialog('submit')"> 审 核 </el-button>
              <el-button size="lg" type="warning" @click="closeDialog('save')"> 确 定 </el-button>
              <el-button size="lg" @click="closeDialog('close')"> 取 消 </el-button>
            </el-form-item>
          </el-form>

        </div>
      </div>
    </el-dialog>
    <dyh-img-choose @imageChoose="imageChoose" ref="dyhImgChooseRef"></dyh-img-choose>
  </div>
</template>
<script>
/* eslint-disable */
import {
  goodsAuditList,
  getClassifyList,
  goodsAudit
} from "@/api/basic.js";
import { commonDownLoadImg } from "@/api/basic.js";
import { removeEmptyValues } from "@/js/public.js";
import { cellStyleOption } from "@/js/sheettablecolumn.js";
import dyhImgChoose from "@/components/dyh-imgChoose.vue";
let pinyin = require("js-pinyin");
export default {
  components: { dyhImgChoose },
  data() {
    return {
      formDialog: false,
      search_value: "", //顶部模糊查询框
      loadingInstance: null, //显示加载动画
      goodsDataShow: false,
      goods_list: [],
      all_goods_list: [],
      cascaderProps: {
        //联级选择框属性
        value: "class_no",
        label: "class_name",
        emitPath: true
      },
      goodsData: {
        barcode: "",
        item_name: "",
        item_subname: "",
        advise_price: "",
        pym: "",
        class_no: "",
        unit_name: "",
        grade: "",
        product_area: "",
        item_size: "",
        shelf_life: "",
        brand_name: "",
        weight_flag: 0,
        image_barcode: {},
        image_front: {},
        image_desc: {}
      },
      srcList: [], //图片列表

      rules: {
        barcode: [
          { required: true, message: "请输入商品条码", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "条码长度在3到20个字符",
            trigger: "blur"
          }
        ],
        item_name: [
          { required: true, message: "请输入商品名称", trigger: "blur" },
          {
            min: 1,
            max: 40,
            message: "商品名称长度在1到40个字符",
            trigger: "blur"
          }
        ],
        item_subname: [
          { required: false, message: "请输入商品简称", trigger: "blur" },
          {
            min: 0,
            max: 40,
            message: "商品简称长度不超过40个字符",
            trigger: "blur"
          }
        ],
        advise_price: [
          { required: false, message: "请输入建议售价", trigger: "blur" },
          {
            type: "number",
            min: 0,
            message: "建议售价必须为大于等于0的数字",
            trigger: "blur",
            transform: (value) => Number(value)
          }
        ],
        pym: [
          { required: false, message: "请输入拼音码", trigger: "blur" },
          {
            min: 0,
            max: 50,
            message: "拼音码长度不超过40个字符",
            trigger: "blur"
          }
        ],
        class_no: [
          { required: true, message: "请选择商品分类", trigger: "change" }
        ],
        unit_name: [
          { required: true, message: "请输入单位", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "计量单位长度在1到20个字符",
            trigger: "blur"
          }
        ],
        grade: [
          { required: false, message: "请输入商品等级", trigger: "blur" },
          {
            min: 0,
            max: 20,
            message: "商品等级长度不超过20个字符",
            trigger: "blur"
          }
        ],
        product_area: [
          { required: false, message: "请输入产地", trigger: "blur" },
          {
            min: 0,
            max: 100,
            message: "产地长度不超过100个字符",
            trigger: "blur"
          }
        ],
        item_size: [
          { required: true, message: "请输入规格", trigger: "blur" },
          {
            min: 0,
            max: 50,
            message: "规格长度不超过50个字符",
            trigger: "blur"
          }
        ],
        shelf_life: [
          { required: true, message: "请输入保质期", trigger: "blur" },
          {
            type: "number",
            min: 0,
            message: "保质期必须为大于等于0的数字",
            trigger: "blur",
            transform: (value) => Number(value)
          }
        ],
        brand_name: [
          { required: false, message: "请输入品牌名称", trigger: "blur" },
          {
            min: 0,
            max: 50,
            message: "品牌名称长度不超过50个字符",
            trigger: "blur"
          }
        ],
        weight_flag: [
          {
            type: "number",
            required: true,
            message: "请选择是否称重商品",
            transform: (value) => Number(value)
          }
        ]
      },
      // 商品条码前复选框选中的值
      checkboxOption: {
        // hideSelectAll: true,
        // defaultSelectedRowKeys: ,
        // defaultSelectedAllRows:true,
        // 行选择改变事件
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          // row选中行的数据 isSelected 选中的情况(true,false)
          if (isSelected === true) {
            this.checkedGoods.push(row.barcode);
          }
          if (isSelected === false) {
            for (var i = 0; i < this.checkedGoods.length; i++) {
              if (this.checkedGoods[i] === row.barcode) {
                this.checkedGoods.splice(i, 1);
              }
            }
          }
        },
        // 全选改变事件
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          if (isSelected === true) {
            this.checkedGoods = [];
            for (var i = 0; i < this.goods_list.length; i++) {
              this.checkedGoods[i] = this.goods_list[i].barcode;
            }
          } else {
            this.checkedGoods = [];
          }
        },
        radioList: [
          {
            label: "只保留数字",
            value: "0"
          } /* ,        {          label: "正常",
          value: "1"
        },
        {
          label: "休息",
          value: "2"
        } */
        ]
      },
      //虚拟滚动
      virtualScrollOption: {
        // 是否开启
        enable: true
      },
      pagination: {
        pageSizes: [50, 100, 150],
        pageSize: 100,
        currentPage: 1,
        disabled: false
      },
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
        ...cellStyleOption
      },
      eventCustomOption: {
        //自定义事件
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            click: (event) => {
              if (row.message) this.warnMessage(row.message);
              //
            }
          };
        }
      },
      columns: [
        // 标题第一列

        {
          field: "index",
          key: "a",
          title: "行号",
          width: 50,
          align: "center",
          fixed: "left",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          }
        },

        // 表头信息
        {
          field: "barcode",
          key: "barcode",
          title: "商品条码",
          align: "left",
          width: 150,
          edit: true,
          fixed: "left"
        },
        {
          field: "item_name",
          key: "item_name",
          title: "商品名称",
          align: "left",
          width: 150,
          edit: true,
          fixed: "left",
          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "item_subname",
          key: "item_subname",
          title: "商品简称",
          align: "left",
          width: 150,
          edit: true,
          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "pym",
          key: "pym",
          title: "拼音码",
          align: "left",
          width: 150,
          edit: true,
          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "class_no",
          key: "class_no",
          title: "类别",
          align: "left",
          width: 100,
          edit: true
        },
        {
          field: "advise_price",
          key: "advise_price",
          title: "建议售价",
          align: "left",
          width: 100,
          edit: true
        },
        {
          field: "brand_name",
          key: "brand_name",
          title: "品牌",
          align: "left",
          width: 100,
          edit: true
        },
        {
          field: "product_area",
          key: "product_area",
          title: "产地",
          align: "left",
          width: 100,
          edit: true
        },
        {
          field: "unit_name",
          key: "unit_name",
          title: "单位",
          align: "left",
          width: 100,
          edit: true
        },
        {
          field: "item_size",
          key: "item_size",
          title: "规格",
          align: "left",
          width: 100,
          edit: true
        },
        {
          field: "grade",
          key: "grade",
          title: "等级",
          align: "left",
          width: 100,
          edit: true
        },
        {
          field: "life_day",
          key: "life_day",
          title: "保质期（天）",
          align: "left",
          width: 150,
          edit: true
        },
        {
          field: "weight_flag",
          key: "weight_flag",
          title: "称重标识",
          align: "left",
          width: 100,
          edit: true
        },
        {
          field: "n",
          key: "n",
          title: "操作",
          width: "100px",
          center: "left",
          fixed: "right",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                <button
                  style="cursor:pointer;background-color: #67C23A !important;border:none;color:#fff;border-radius:2px;height:30px"
                  class="upload-button"
                  on-click={() => this.additionalGoodsInfo(row, rowIndex)}
                >
                  补 充 数 据
                </button>
              </span>
            );
          }
        }
      ], // 标题第一列
      classList: {}//类别
    };
  },
  watch: {
    "goodsData.item_name": {
      handler(n, o) {
        this.goodsData.pym = pinyin.getCamelChars(n);
      },
      deep: true
    },
    search_value: {
      handler(ns, os) {
        console.log("所有所有------------", this.all_goods_list);
        if ((ns == "" || ns.length == 0) && (this.all_goods_list != [] && this.all_goods_list.length > 0)) {
          this.goods_list = JSON.parse(JSON.stringify(this.all_goods_list));
          this.all_goods_list = [];
        }
        this.searchGoods(ns);
      }
    }
  },
  async mounted() {
    this.goodsDataShow = false;
    this.loadingInstance = this.$veLoading({
      target: "#loading-container",
      // 等同于
      // target:"#loading-container"
      overlayBackgroundColor: "rgba(255,255,255,.5)",
      name: "grid"
    });
    this.getAuditList(); //获取待审核列表
    this.goodsDataShow = true;

    this.classList = await getClassifyList(); //获取所有类别
  },
  methods: {
    searchGoods(str) {
      if (this.all_goods_list.length === 0) {
        this.all_goods_list = JSON.parse(JSON.stringify(this.goods_list));
      }
      let list = [];
      for (let i = 0; i < this.all_goods_list.length; i++) {
        if (this.all_goods_list[i].barcode.indexOf(str) > -1 || this.all_goods_list[i].item_name.indexOf(str) > -1) {
          list.push(this.all_goods_list[i]);
        }
      }
      this.goods_list = list;
    },
    /**
     * choose组件返回值
     * @param e {object} 组件选中图片返回
     */
    imageChoose(e) {
      console.log("e-----------------------", e);
      this.$set(this.goodsData[e.key], "url", e.url);
      if (e.media_no) {
        this.$set(this.goodsData[e.key], "media_no", e.media_no);
      }
    },
    /**
     * 选择图片
     * @param {string} key 当前是哪个值
     */
    chooseImage(key) {
      this.$refs.dyhImgChooseRef.showDyhImageCooseDialog({ key: key, item_name: this.goodsData.item_name, url: this.goodsData[key].url ? this.goodsData[key].url : "" });
    },
    /**
     * 通过key删除图片
     * @param {"image_barcode"|"image_front"|"image_desc"} key 需要删除的key
     */
    deleteImage(key) {
      this.goodsData[key] = {};
    },
    /**
     *关闭详情页
     * @param {'submit'|'save'|'close'} key
     */
    closeDialog(key) {
      const that = this;
      if (key == 'close') {
        that.formDialog = false;
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) { //成功
          const data = {
            ...this.goodsData,
            class_no: this.goodsData.class_no[this.goodsData.class_no.length - 1],
            image_barcode: this.goodsData.image_barcode.media_no ? this.goodsData.image_barcode.media_no : this.goodsData.image_barcode.url,
            image_front: this.goodsData.image_front.media_no ? this.goodsData.image_front.media_no : this.goodsData.image_front.url,
            image_desc: this.goodsData.image_desc.media_no ? this.goodsData.image_desc.media_no : this.goodsData.image_desc
          };
          if (key === 'submit') {
            this.goodsData = removeEmptyValues(data);
            that.onSubmit([this.goodsData.chooseIndex]);
          }
          this.$set(this.goodsData, "class_state", "8");
          that.formDialog = false;
        } else { //如果修改不合规，则不能退出
          that.formDialog = true;
        }
      });
    },
    /**
     * 点击上一页或者下一页
     * @param {"+"|"-"} key
     */
    pageChange(key) {
      if (key === "+") {
        this.pagination.currentPage += 1;
        if (this.pagination.currentPage > 100) {
          this.pagination.currentPage = 100;
        }
      } else if (key === "-") {
        this.pagination.currentPage -= 1;
        if (this.pagination.currentPage < 1) this.pagination.currentPage = 1;
      }
      this.getAuditList();
    },
    /* paginationChange(e) {
      this.changeShowList();
    }, */
    /**
     * 点击审核按钮
     */
    audit() {
      let list = [];
      this.goods_list.forEach((item, index) => {
        if (item.class_state === "8" || (item.barcode && item.item_name && item.class_no && item.unit_name && item.shelf_life)) {
          list.push(index);
        }
      })
      if (list.length === 0) {
        this.warnMessage("请先完善信息");
        return;
      }
      this.onSubmit(list);
    },
    /**
     * 保存修改
     */
    saveUpdate() { },
    /**
     * 提交审核
     * @param {number[]} list 需要提交审核的索引
     */
    async onSubmit(list) {
      if (list.length === 0) return;
      let subList = [];

      for (let i = 0; i < list.length; i++) {
        const goodsData = this.goods_list[list[i]];
        let data = removeEmptyValues({
          ...goodsData,
          barcode: goodsData.barcode.trim(),
          class_no: goodsData.class_no[goodsData.class_no.length - 1],
          image_barcode: goodsData.image_barcode.media_no ? goodsData.image_barcode.media_no : goodsData.image_barcode.url ? goodsData.image_barcode.url : "",
          image_front: goodsData.image_front.media_no ? goodsData.image_front.media_no : goodsData.image_front.url ? goodsData.image_front.url : "",
          image_desc: goodsData.image_desc.media_no ? goodsData.image_desc.media_no : goodsData.image_desc.url ? goodsData.image_desc.url : ""
        })
        subList.push(data);
      }
      const res = await goodsAudit(subList);
      console.log("测试商品数据：", res);
      if (res.data && res.data.return_code === "SUCCESS" && res.data.result_code == "SUCCESS" && res.data.resp_data) {
        const list = res.data.resp_data;
        console.log("测试商品数据list：", list);
        const sList = [], eList = [];//sList 成功列表  eList 失败列表
        const llist = [];//最终列表
        for (let i = 0; i < list.length; i++) {
          if (list[i].state === false) eList.push(list[i].barcode.trim());
          if (list[i].state == true) sList.push(list[i].barcode.trim());
        }
        for (let i = 0; i < this.goods_list.length; i++) {//更新状态
          if (!(sList.indexOf(this.goods_list[i].barcode.trim()) > -1)) {
            if (eList.indexOf(this.goods_list[i].barcode.trim()) > -1) this.$set(this.goods_list[i], "class_state", "6");
            llist.push(this.goods_list[i]);
          }
        }
        this.goods_list = llist;
        this.$message({
          message: `审核完成，成功${sList.length}条，失败${eList.length}条`,
          type: "success",
          duration: 3000
        });
      }
    },
    /**
     * 获取到待审核商品列表
     */
    async getAuditList() {
      this.loadingInstance.show();
      this.pagination.disabled = true;
      setTimeout(() => {
        this.pagination.disabled = false;
        this.loadingInstance.destroy();
      }, 3000);
      const res = await goodsAuditList(
        this.pagination.pageSize,
        Number(this.pagination.currentPage) - 1 >= 0
          ? Number(this.pagination.currentPage) - 1
          : 0
      );
      if (
        res.data &&
        res.data.return_code === "SUCCESS" &&
        res.data.result_code === "SUCCESS" &&
        res.data.resp_data
      ) {
        const list = res.data.resp_data;
        this.goods_list = [];
        this.all_goods_list = [];
        list.forEach((item, index) => {
          this.goods_list.push({
            ...item,
            barcode: item.barcode.trim(),
            weight_flag: item.weight_flag ? item.weight_flag : 0,
            image_barcode: item.image_barcode.indexOf("http") > -1 ? { url: item.image_barcode } : { url: "", media_no: item.image_barcode },
            image_front: item.image_front.indexOf("http") > -1 ? { url: item.image_front } : { url: "", media_no: item.image_front },
            image_desc: item.image_desc.indexOf("http") > -1 ? { url: item.image_desc } : { url: "", media_no: item.image_desc },
            rowKey: index
          });
        });
        if (this.pagination.currentPage === "") this.pagination.currentPage = 1;
        this.pagination.disabled = false;
        this.loadingInstance.destroy();
      }
    },
    /**
     * 将选中行的数据赋值到data
     * @param {object} item 点击的行数据
     * @param {number} index 点击的行索引
     */
    async additionalGoodsInfo(item, index) {
      //TODO:搜索商品是否存在 const res = await goodsSearch(item.barcode.trim(), true);
      this.goodsData = this.goods_list[index];
      this.$set(this.goodsData, 'chooseIndex', index);
      /**
       * 获取预览图片
       */
      if (this.goodsData.image_barcode.media_no) {
        this.goodsData.image_barcode.url = "data:image/png;base64," + await commonDownLoadImg(this.goodsData.image_barcode.media_no);
      }
      if (this.goodsData.image_desc.media_no) {
        this.goodsData.image_desc.url = "data:image/png;base64," + await commonDownLoadImg(this.goodsData.image_desc.media_no);
      }
      if (this.goodsData.image_front.media_no) {
        this.goodsData.image_front.url = "data:image/png;base64," + await commonDownLoadImg(this.goodsData.image_front.media_no);
      }
      this.formDialog = true;
      //console.log("this.goodsData", this.goodsData);
    }
  }
};
</script>
<style lang="less" scoped>
.bg-fa {
  display: flex;
  flex-direction: column;
}

.image-fa {
  width: 200px;
  height: 200px;
  margin: 0 20px;
  min-width: 180px;

  .block {
    cursor: pointer;
  }

  .demonstration {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}

/deep/.el-input__inner {
  padding-right: 3px !important;
}

.in-line {
  display: flex;
  width: 100%;
  height: 40px;
  align-items: center;
  justify-content: right;

}

.dialog-fa {
  width: 100%;
  display: flex;
}

/deep/#page-input {
  text-align: center !important;
}

.close {
  width: 25px;
  height: 25px;
  font-size: 30px;
  color: red;
  cursor: pointer;
  margin-left: 10px;
  position: absolute;
  top: 0px;
  right: 0px;
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: rgba(0, 0, 0, 0.2);
}

.form-image-info {
  cursor: pointer;
  width: 170px;
  height: 170px;
}
</style>